<style lang="scss" scoped>
@import "core";

.dn-loading {
  $my-overflow: 40px;

  position: fixed;
  z-index: 327677;
  top: -$my-overflow;
  left: -$my-overflow;
  right: -$my-overflow;
  bottom: -$my-overflow;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=);
}

.myfade-enter-active, .myfade-leave-active {
  transition: opacity .5s
}
.myfade-enter, .myfade-leave-to {
  opacity: 0
}
</style>



<template>
<transition name="myfade">
  <div :class="classes" v-if="active">
    <dn-spinner />
  </div>
</transition>
</template>



<script>



export default {
  data() {
    return {
      active: false,
    }
  },



  computed: {
    classes() {
      return {
        'dn-loading': true,
      }
    },
  },

  methods: {
    show() {
      this.active = true;
    },
    hide() {
      this.active = false;
    },
  },
}
</script>


// WEBPACK FOOTER //
// Loading.vue?6bc8d914